module.exports = __webpack_public_path__ + "static/img/hdzq1.a3af4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hdzq1.png
// module id = 06PG
// module chunks = 3